var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_539_52202)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8593 1.76948e-05H43.151C44.0592 -0.000668299 44.9587 0.177806 45.7979 0.525222C46.6371 0.872639 47.3995 1.38217 48.0415 2.02465C48.6835 2.66713 49.1924 3.42993 49.5392 4.26937C49.886 5.10882 50.0638 6.00843 50.0624 6.91668V57.0833C50.0638 57.9916 49.886 58.8912 49.5392 59.7307C49.1924 60.5701 48.6835 61.3329 48.0415 61.9754C47.3995 62.6179 46.6371 63.1274 45.7979 63.4748C44.9587 63.8222 44.0592 64.0007 43.151 64H20.8593C19.0249 64 17.2656 63.2713 15.9685 61.9742C14.6713 60.677 13.9426 58.9178 13.9426 57.0833V6.90627C13.9419 5.99826 14.1205 5.09903 14.4679 4.26014C14.8154 3.42124 15.325 2.65917 15.9676 2.01759C16.6101 1.37601 17.373 0.867548 18.2124 0.521333C19.0518 0.175118 19.9513 -0.00203844 20.8593 1.76948e-05ZM15.9791 54.3958H48.0208V7.52085H15.9791V54.3958ZM31.9947 56.5625C32.5574 56.5625 33.1074 56.7294 33.5752 57.0421C34.0429 57.3548 34.4074 57.7993 34.6225 58.3192C34.8376 58.8391 34.8936 59.4112 34.7834 59.963C34.6733 60.5147 34.4019 61.0214 34.0037 61.4189C33.6055 61.8164 33.0983 62.0869 32.5463 62.196C31.9943 62.3051 31.4224 62.2481 30.9028 62.0321C30.3833 61.816 29.9395 61.4507 29.6277 60.9824C29.3158 60.514 29.1499 59.9637 29.151 59.4011C29.151 59.0279 29.2246 58.6583 29.3675 58.3136C29.5105 57.9689 29.7201 57.6557 29.9842 57.3921C30.2483 57.1284 30.5619 56.9194 30.9068 56.7771C31.2518 56.6347 31.6215 56.5618 31.9947 56.5625Z",
    fill: "#74747B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.2656L32 23.7656L36.5 28.2656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 23.7656V35.7656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 38.7656C28.835 40.7156 35.165 40.7156 41 38.7656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_52202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.cc6d082cea20d5f8040e232e4ff20754.svg";
export { ForwardRef as ReactComponent };